import type { CampaignType, PropagationStatus } from "@/@types/campaign-propagation";

export interface FilterStateCampaignPropagation {
  campaignType?: CampaignType;
  overallStatus?: PropagationStatus;
  page: number;
  limit: number;
}

export const DEFAULT_FILTERS: FilterStateCampaignPropagation = {
  page: 1,
  limit: 10, // Padrão do projeto
};
